import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, []);  // logout fonksiyonunu dependency'den kaldır

  // logout() zaten window.location.href ile yönlendiriyor
  // Navigate kullanmıyoruz - çift yönlendirme olmasın
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted">Logging out...</p>
      </div>
    </div>
  );
};

export default Logout;
